<script type="text/javascript">
	import { onMount } from "svelte";
	import { get, writable } from "svelte/store";
	import MapLayer from "./Enums/MapLayer";
	import MapDataSource from "./Enums/MapDataSource";
	import MapLayerManager from "./MapLayerManager";
	import AlertsStore from "../Alerts/Store";
	import MapStore from "./Store";
	import VesselHistoryStore from "../UI/VesselHistory/Store";
	import AircraftStore from "../Aviation/AircraftStore";
	import GeoHelper from "../Helpers/GeoHelper";
	import VesselProperty from "../Models/Enums/VesselProperty";

	let map = MapStore.mapbox.instance;
	let initialised = MapStore.meta.initialised;
	let alertsTimeSliderValue = AlertsStore.vesselGroup.timeSliderData.value;
	let aircraftTimeSliderValue = AircraftStore.results.group.timeSliderData.value;

	let focusedAlertVesselImos = AlertsStore.vesselGroup.focused[VesselProperty.IMO];
	let selectedAlertVesselImos = AlertsStore.vesselGroup.selected[VesselProperty.IMO];
	let lastUpdatedAlerts;
	let lastUpdatedVH;
	let lastUpdatedAircraft;

	let groups = [];
	onMount(() => {
		groups = [];
		groups.push(AlertsStore.vesselGroup);
		groups.push(VesselHistoryStore.vesselGroup);
		groups.push(AircraftStore.results.group);

		lastUpdatedAlerts = AlertsStore.vesselGroup.lastUpdated;
		lastUpdatedVH = VesselHistoryStore.vesselGroup.lastUpdated;
		lastUpdatedAircraft = AircraftStore.results.group.lastUpdated;
	});

	$: {
		$lastUpdatedAlerts;
		$lastUpdatedVH;
		$lastUpdatedAircraft;
		$alertsTimeSliderValue;
		$aircraftTimeSliderValue;
		if ($initialised) {
			// For each group, we can have one focused/selected vessel with the corners.
			// Maybe we'll make them all have it later. We'll see
			let useVessel = null;
			let useVesselFeatures = [];
			for (let i = 0; i < groups.length; i++) {
				if (get(groups[i].visible) && groups[i].countSelected() == 1) {
					const uniquePropertyType = groups[i].uniqidType;
					const uniquePropertyValue = get(groups[i].selected[uniquePropertyType])[0];
					const vessel = groups[i].find({[uniquePropertyType]: uniquePropertyValue});
					if (vessel !== false && vessel.visible && vessel.currentFeature) {
						useVesselFeatures.push(vessel.currentFeature);
						useVessel = vessel;
					}
				}
			}
			if (useVessel !== null && useVessel.isSTS()) {
				// TODO: (potentially) make the secondary box 50% size or 50% transparent.
				useVesselFeatures.push(useVessel.getSTSPartner().currentFeature);
			}
			$map.getSource(MapDataSource.VESSEL_FOCUSED).setData(GeoHelper.emptyGeoJson(useVesselFeatures));
		}
	}
</script>

